import { h } from 'preact';
import { getEarningsEstimatesBySecurity } from '@os/cloudquote';
import { Text } from 'preact-i18n';
import { formatNumber } from '../../lib/util';
import createDataTable from '../cloudquote-data-table';

export const INTL_NS = 'analysts-panel.insiderTransactions';

function pick(data, key) {
	return String(data.rows[0][data.columns.indexOf(key)]);
}

function priceFormat(value) {
	return formatNumber(value, { Decimals: 2, Default: '-' });
}

export const InsiderTransactionsDataTable = createDataTable({
	headers: [
		<Text id={`${INTL_NS}.earningsEstimate`} />,
		<Text id={`${INTL_NS}.currentQtr`} />,
		<Text id={`${INTL_NS}.nextQtr`} />,
		<Text id={`${INTL_NS}.currentYear`} />,
		<Text id={`${INTL_NS}.nextYear`} />
	],
	cells: [
		'Label',
		'Current Qtr',
		'Next Qtr',
		'Current Year',
		'Next Year'
	],
	sort: function normalizeEarningsEstimatesData(data) {
		if (!data || !data.rows || !data.rows.length) { return data; }
		return {
			columns: [
				'Label',
				'Current Qtr',
				'Next Qtr',
				'Current Year',
				'Next Year'
			],
			// this table will have 5 rows
			rows: [
				[
					<Text id={`${INTL_NS}.numberOfAnalysts`} />,
					pick(data, 'curQuarterEstimateCount'),
					pick(data, 'nextQuarterEstimateCount'),
					pick(data, 'curYearEstimateCount'),
					pick(data, 'nextYearEstimateCount')
				],
				[
					<Text id={`${INTL_NS}.averageEstimate`} />,
					priceFormat(pick(data, 'curQuarterMeanEstimate')),
					priceFormat(pick(data, 'nextQuarterMeanEstimate')),
					priceFormat(pick(data, 'curYearMeanEstimate')),
					priceFormat(pick(data, 'nextYearMeanEstimate'))
				],
				[
					<Text id={`${INTL_NS}.lowEstimate`} />,
					priceFormat(pick(data, 'curQuarterLowEstimate')),
					priceFormat(pick(data, 'nextQuarterLowEstimate')),
					priceFormat(pick(data, 'curYearLowEstimate')),
					priceFormat(pick(data, 'nextYearLowEstimate'))
				],
				[
					<Text id={`${INTL_NS}.highEstimate`} />,
					priceFormat(pick(data, 'curQuarterHighEstimate')),
					priceFormat(pick(data, 'nextQuarterHighEstimate')),
					priceFormat(pick(data, 'curYearHighEstimate')),
					priceFormat(pick(data, 'nextYearHighEstimate'))
				],
				[
					<Text id={`${INTL_NS}.priorYearEps`} />,
					priceFormat(pick(data, 'prevPrevPrevQuarterActualEPS')),
					priceFormat(pick(data, 'prevPrevQuarterActualEPS')),
					priceFormat(pick(data, 'prevYearActualEPS')),
					priceFormat(pick(data, 'curYearEstimatedEPS'))
				]
			]
		};
	},
	apiMethod: getEarningsEstimatesBySecurity
});
